import { Observable } from 'rxjs';
import { SessionAnuglarService } from '../../../../core/session-anuglar.service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

export class DefaultHttpService<T> {
	constructor(
		public httpClient: HttpClient,
		private url: string,
	) { }

	fetchId(id: number): Observable<T> {
		return this.httpClient.get<T>(`${this.url}/${id}`, this.getHttpOptions)
	}

	fetchListAgencia(idAgencia: number,id: number, filter: any): Observable<T> {
		const params = this.converterFiltroParaHttpParam(filter);
		return this.httpClient.get<T>(`${this.url}/${idAgencia}/${id}`, { params: params, headers: this.getHttpOptions.headers })
	}
	fetchList(id: number, filter: any): Observable<T> {
		const params = this.converterFiltroParaHttpParam(filter);
		return this.httpClient.get<T>(`${this.url}/${id}`, { params: params, headers: this.getHttpOptions.headers })
	}
	list(filter?: any): Observable<T[]> {
		let options = { params: null, headers: this.getHttpOptions.headers }
		let params
		if(filter){
			params = this.converterFiltroParaHttpParam(filter);
			options.params = params
		}
		return this.httpClient.get<T[]>(this.url, { params: params, headers: this.getHttpOptions.headers });
	}
	dispatch(body: Object): Observable<T> {
		return this.httpClient.post<T>(`${this.url}`, body, this.getHttpOptions)
	}
	auth(body: Object): Observable<T> {
		return this.httpClient.post<T>(`${this.url}`, body, this.httpOptionsPublic)
	}
	upload(formData: FormData): Observable<HttpResponse<T>> {
		return this.httpClient.post<HttpResponse<T>>(`${this.url}`, formData, this.getHttpUploadOptions)
	}
	uploadId(formData: FormData, id: number): Observable<HttpResponse<T>> {
		return this.httpClient.post<HttpResponse<T>>(`${this.url.replace(":id", id.toString())}`, formData, this.getHttpUploadOptions)
	}
	update(id: number, body: Object): Observable<T> {
		return this.httpClient.put<T>(`${this.url}/${id}`, body, this.getHttpOptions)
	}
	delete(id: number): Observable<T> {
		return this.httpClient.delete<T>(`${this.url}/${id}`, this.getHttpOptions)
	}
	setUrl(url): void {
		this.url = url
	}
	getUrl(): string {
		return this.url
	}
	get getToken(){ 
		return SessionAnuglarService.getTokenApiAlerta()
	}

	/**
	* Options do httpClient
	* @object Options {
			 headers?: HttpHeaders | {
					 [header: string]: string | string[];
			 };
			 observe?: 'body';
			 params?: HttpParams | {
					 [param: string]: string | string[];
			 };
			 reportProgress?: boolean;
			 responseType: 'blob';
			 withCredentials?: boolean;
	 }
	 */
	
	get getHttpOptions() {
		return {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				// 'Access-Control-Allow-Origin': '*',
				// 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
				'Authorization': `Bearer ${this.getToken}`,
			}),
			params: null
		}
	}

	get getHttpUploadOptions() {
		return {
			headers: new HttpHeaders({
				'Authorization': `Bearer ${this.getToken}`,
			}),
			params: null
		}
	}

	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
			// 'Access-Control-Allow-Origin': '*',
			// 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
			'Authorization': `Bearer ${this.getToken}`,
		}),
		params: null
	};
	
	httpOptionsPublic = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		}),
		params: null
	};
	
	httpUploadOptions = {
		headers: new HttpHeaders({
			'Authorization': `Bearer ${this.getToken}`,
		})
	};

	/**
	 * Options do httpClient
	 * @object Options {
				headers?: HttpHeaders | {
						[header: string]: string | string[];
				};
				observe?: 'body';
				params?: HttpParams | {
						[param: string]: string | string[];
				};
				reportProgress?: boolean;
				responseType: 'blob';
				withCredentials?: boolean;
		}
	 */
	public setHttpOptions(httpOptions: any): void {
		this.httpOptions = httpOptions
	}

	/**
	 * Retorna as Options do httpClient
	 * @returns Options {
				headers?: HttpHeaders | {
						[header: string]: string | string[];
				};
				observe?: 'body';
				params?: HttpParams | {
						[param: string]: string | string[];
				};
				reportProgress?: boolean;
				responseType: 'blob';
				withCredentials?: boolean;
		}
	 */
	// public getHttpOptions() {
	// 	return this.httpOptions
	// }

	public converterFiltroParaHttpParam(filter: any, params?: HttpParams): HttpParams {
		if (!params) {
			params = new HttpParams();
		}
		if (filter) {
			Object.keys(filter).forEach(key => {
				params = params.append(key, filter[key]);
			});
		}
		return params;
	}

}




// WEBPACK FOOTER //
// ./src/app/modulos/portal/telas/alerta-monitoramento/default-http.service.ts